"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFactoryBinding = void 0;
const resolveFactoryBindingCallback_1 = require("../calculations/resolveFactoryBindingCallback");
const resolveSingletonScopedBinding_1 = require("./resolveSingletonScopedBinding");
exports.resolveFactoryBinding = (0, resolveSingletonScopedBinding_1.resolveSingletonScopedBinding)(resolveFactoryBindingCallback_1.resolveFactoryBindingCallback);
//# sourceMappingURL=resolveFactoryBinding.js.map